import { normalizePartnerAgentCode } from "@/lib/partners/partner-agent-cookie"

export type PartnerAgentSignupSource = "url" | "local_storage" | "cookie"

export function resolvePartnerAgentCodeAtSignup(input: {
  urlCode: string | null | undefined
  localStorageCode: string | null | undefined
  cookieCode: string | null | undefined
}): { code: string | null; source: PartnerAgentSignupSource | null } {
  const url = normalizePartnerAgentCode(input.urlCode)
  if (url) return { code: url, source: "url" }

  const ls = normalizePartnerAgentCode(input.localStorageCode)
  if (ls) return { code: ls, source: "local_storage" }

  const cookie = normalizePartnerAgentCode(input.cookieCode)
  if (cookie) return { code: cookie, source: "cookie" }

  return { code: null, source: null }
}

export function resolvePartnerAgentCapturedAtAtSignup(input: {
  hasUrlCode: boolean
  localStorageCapturedAt: string | null | undefined
  now?: Date
}): string | null {
  if (input.hasUrlCode) {
    return (input.now ?? new Date()).toISOString()
  }
  const raw = input.localStorageCapturedAt?.trim()
  return raw || null
}
